import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMail48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="mail">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44.6566 8H3.34333L23.278 28.8013C23.6716 29.2121 24.3283 29.2121 24.7219 28.8013L44.6566 8ZM2 9.48883V38.5858L16.2389 24.3469L2 9.48883ZM44.5858 40H3.41424L17.6231 25.7912L21.834 30.1852C23.015 31.4175 24.9849 31.4175 26.1659 30.1852L30.3769 25.7911L44.5858 40ZM46 38.5858V9.48871L31.761 24.3468L46 38.5858ZM0 8C0 6.89543 0.895431 6 2 6H46C47.1046 6 48 6.89543 48 8V40C48 41.1046 47.1046 42 46 42H2C0.895432 42 0 41.1046 0 40V8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMail24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="mail">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 3C0.447715 3 0 3.44772 0 4V20C0 20.5523 0.447715 21 1 21H23C23.5523 21 24 20.5523 24 20V4C24 3.44772 23.5523 3 23 3H1ZM2 6.41434V17.5858L7.58574 12.0001L2 6.41434ZM8.99995 13.4143L3.41424 19H20.5858L15 13.4142L13.4142 15.0001C12.6331 15.7811 11.3668 15.7811 10.5857 15.0001L8.99995 13.4143ZM16.4142 12L22 17.5858V6.41424L16.4142 12ZM20.5858 5H3.41409L12 13.5859L20.5858 5Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMail16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="mail">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 2C1.44772 2 1 2.44772 1 3V12.5859L0.959595 12.6263L1 12.6667V13C1 13.5523 1.44772 14 2 14H2.33329L2.37381 14.0405L2.41432 14H15.5857L15.6262 14.0405L15.6667 14H16C16.5523 14 17 13.5523 17 13V12.6667L17.0404 12.6263L17 12.5859V3C17 2.44772 16.5523 2 16 2H2ZM12.4142 8.00007L15 10.5859V5.41424L12.4142 8.00007ZM11 9.41428L9.70706 10.7072C9.31654 11.0977 8.68337 11.0977 8.29285 10.7072L6.99999 9.41433L4.41432 12H13.5857L11 9.41428ZM5.58578 8.00012L3 5.41434V10.5859L5.58578 8.00012ZM4.41409 4L8.99995 8.58586L13.5858 4H4.41409Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
